/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/roles-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/roles-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/roles-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-roles-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/roles.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-22T23:44:13.686Z
 * Source config: config/entities/roles-entity-config.ts
 * Public fields: 7/7 total fields
 */

import { Type, Static } from "@sinclair/typebox";

// TypeBox schemas for runtime validation (public fields only)
export const RolesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  name: Type.Any(), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  is_default: Type.Union([Type.Boolean(), Type.Null()]), // is_default field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
});

export const CreateRolesSchema = Type.Object({
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  name: Type.Any(), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  is_default: Type.Union([Type.Boolean(), Type.Null()]), // is_default field
});

export const UpdateRolesSchema = Type.Object({
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  name: Type.Any(), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  is_default: Type.Union([Type.Boolean(), Type.Null()]), // is_default field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type RolesRow = Static<typeof RolesSchema>;
export type RolesInsert = Static<typeof CreateRolesSchema>;
export type RolesUpdate = Static<typeof UpdateRolesSchema>;

// Legacy type aliases for backward compatibility
export type Roles = RolesRow;
export type CreateRoles = RolesInsert;
export type UpdateRoles = Static<typeof UpdateRolesSchema>;

// Field configuration metadata
export const RolesFieldConfig = {
  filterable: ["id", "organization_id"] as const,
  sortable: ["created_at", "updated_at"] as const,
  searchable: [] as const,
  required: ["id", "name"] as const,
  readonly: ["id", "created_at", "updated_at"] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from "../../../../../config/search/global-search-config.js";

export interface RolesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface RolesResponse {
  data: Roles[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleRolesResponse {
  data: Roles | null;
  error: Error | null;
}
